import React from "react";
import "./ApprovalDetailsForm.scss"; // We'll create this CSS file

export const ApprovalDetailsForm: React.FC = () => {
  return (
    <div className="form-section-eight-container">
      {/* Type du véhicule (Véhicule type) */}
      <div className="form-row header-label-row">
        <div className="label-cell single-line-label">
          <label>Type du véhicule (Véhicule type)</label>
        </div>
      </div>
      <div className="form-row two-by-two-grid-row">
        <div className="checkbox-item-cell">
          <span className="checkbox"></span>{" "}
          <label>Camion-citerne (Tank truck)</label>
        </div>
        <div className="checkbox-item-cell">
          <span className="checkbox"></span>{" "}
          <label>Camion frigorifique (Refrigerated truck)</label>
        </div>
      </div>
      <div className="form-row two-by-two-grid-row">
        <div className="checkbox-item-cell">
          <span className="checkbox"></span>{" "}
          <label>Camion Conteneur (Container truck)</label>
        </div>
        <div className="checkbox-item-cell other-option-cell">
          <span className="checkbox"></span> <label>Autre (Other):</label>
          <div className="input-line short-input-line"></div>
        </div>
      </div>

      {/* Date d'émission (Issue Date) / Lieu d'émission (Issue place) */}
      <div className="form-row two-column-row header-label-row">
        <div className="label-cell two-col-item">
          <label>Date d'émission (Issue Date)</label>
        </div>
        <div className="label-cell two-col-item">
          <label>Lieu d'émission (Issue place)</label>
        </div>
      </div>
      <div className="form-row two-column-row input-line-row">
        <div className="input-cell two-col-item"></div>
        <div className="input-cell two-col-item"></div>
      </div>

      {/* Valide à partir de (Valid from) */}
      <div className="form-row header-label-row">
        <div className="label-cell single-line-label">
          <label>Valide à partir de (Valid from)</label>
        </div>
      </div>
      <div className="form-row input-line-row">
        <div className="input-cell full-width-input"></div>
      </div>

      {/* Numéro du contrat (contract number) / Valide Jusqu'à (Valid until) */}
      <div className="form-row two-column-row header-label-row">
        <div className="label-cell two-col-item">
          <label>Numéro du contrat (contract number)</label>
        </div>
        <div className="label-cell two-col-item">
          <label>Valide Jusqu'à (Valid until)</label>
        </div>
      </div>
      <div className="form-row two-column-row input-line-row">
        <div className="input-cell two-col-item"></div>
        <div className="input-cell two-col-item"></div>
      </div>

      {/* Axe autorisé (authorized route) / Nombre de voyage autorisé (Number of trip agreed) */}
      <div className="form-row two-column-row header-label-row">
        <div className="label-cell two-col-item">
          <label>Axe autorisé (authorized route)</label>
        </div>
        <div className="label-cell two-col-item">
          <label>Nombre de voyage autorisé (Number of trip agreed)</label>
        </div>
      </div>
      <div className="form-row two-column-row input-line-row">
        <div className="input-cell two-col-item"></div>
        <div className="input-cell two-col-item"></div>
      </div>

      {/* Nature de Marchandises autorisées (type of authorized goods) */}
      <div className="form-row header-label-row">
        <div className="label-cell single-line-label">
          <label>
            Nature de Marchandises autorisées (type of authorized goods)
          </label>
        </div>
      </div>
      <div className="form-row input-line-row attachment-row">
        <div className="input-cell full-width-input attachment-text-cell">
          <p>VOIR DOCUMENT EN ANNEXE / ATTACHED FILES</p>
        </div>
      </div>
    </div>
  );
};
